// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"335":"c96fef97","410":"bda2bb45","1604":"c96fef97","2414":"ccea2529","3142":"91876511","9477":"c96fef97"}[chunkId] + ".chunk.css";
};